import CardBody from "components/card/CardBody";
import CustomCard from "components/card/CustomCard";
import CustomCardHeader from "components/card/CustomCardHeader";
import { SemiTransparentButton } from "components/CustomButton";
import CustomIcon from "components/CustomIcon";
import ImageWrapper from "components/table/ImageWrapper"
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { TableHeader } from "components/table/CustomTable"
import { TableCell } from "components/table/CustomTable"
import { TableRow } from "components/table/CustomTable"
import PredictionCandidateForm from "./components/PredictionCandidateForm";
import CustomTableItemLoader from "components/CustomTableItemLoader";
import CustomButton from "components/CustomButton"
import { DangerButton } from "components/CustomButton"

import CustomTable from "components/table/CustomTable";
import ConfirmModal from "components/ConfirmModal";
import Viewer from "react-viewer";
import { tryGetCandidates } from "redux/slices/predictionSlice";
import { tryDeleteCandidate } from "redux/slices/predictionSlice";


const PredictionCandidateList = () => {

  const { category_id } = useParams()
  const [showModal, setShowModal] = useState();
  const [showConfirmModal, setShowConfirmModal] = useState()
  const dispatch = useDispatch()
  const [imagePreview, setImagePreview] = useState({
    visible: false,
    image: {},
  })

  const {
    candidate: { data, loading, error, processing ,init}
  } = useSelector((state) => state.prediction)

  useEffect(() => {
    setShowModal()
    setShowConfirmModal()
  }, [data])

  useEffect(() => {
    if (category_id)
      dispatch(tryGetCandidates(category_id))
  }, [category_id])


  const removePredictionCandidate = () => {
    dispatch(
      tryDeleteCandidate({
        id: showConfirmModal.id,
      }),
    )
  }

  return (
    <div className="h-auto px-3 -mt-24 md:px-8">
      <div className="container max-w-full mx-auto">
        <div className="px-4 mb-16 grid grid-cols-1">
          <CustomCard>
            <CustomCardHeader contentPosition="none">
              <div className="flex items-center justify-between w-full">
                <h2 className="text-2xl text-white">Prediction Candidates</h2>
                <SemiTransparentButton onClick={() => setShowModal({ id: category_id })}>
                  + Add New
            </SemiTransparentButton>
              </div>

            </CustomCardHeader>
            <CardBody>
              <CustomTable>
                <thead>
                  <TableRow>
                    <TableHeader>Title</TableHeader>
                    <TableHeader className="w-36">App Image</TableHeader>
                    <TableHeader className="w-36">Web Image</TableHeader>
                    <TableHeader className="w-36">Link</TableHeader>
                  </TableRow>
                </thead>
                {loading || error.length || !data.length || !init ? (
                  <CustomTableItemLoader
                    loading={loading}
                    error={error}
                    isEmpty={!data.length}
                    count={10}
                    colSpan={6}
                    key="notification-scheduled"
                    retry={() => {
                    }}
                  />
                ) : (
                  <tbody>
                    {data?.map((prediction_candidate, index) => (
                      <PredictionCandidateItem
                        key={`${prediction_candidate}-${index}`}
                        item={prediction_candidate}
                        setImage={setImagePreview}
                        onEdit={() => {
                          setShowModal(prediction_candidate)
                        }}
                        onDelete={() => {
                          setShowConfirmModal({
                            id: prediction_candidate.id
                          })
                        }}
                      />
                    ))}
                  </tbody>
                )}
              </CustomTable>

            </CardBody>

          </CustomCard>
        </div>
      </div>
      <PredictionCandidateForm
        loading={processing}
        showModal={showModal}
        setShowModal={setShowModal}
      />
      <ConfirmModal
        children="This will remove prediction_candidate. Are you sure?"
        disabled={processing}
        showModal={!!showConfirmModal}
        setShowModal={() => setShowConfirmModal()}
        onConfirm={removePredictionCandidate}
      />
      <Viewer
        visible={imagePreview.visible}
        onClose={() => {
          setImagePreview({ visible: false, image: {} })
        }}
        images={[imagePreview?.image]}
      />
    </div>
  )

}

export default PredictionCandidateList;


const PredictionCandidateItem = ({
  item,
  onEdit,
  onDelete,
  setImage,
  ...props
}) => {

  return (
    <TableRow {...props}>
      <TableCell>
        <div className="font-bold mb-1 truncate link hover:opacity-80">{item?.name}</div>
      </TableCell>
      <TableCell>
        <ImageWrapper imageUrl={item.app_image_url} onImageClicked={() => {
          setImage({
            visible: true,
            image: { src: item.app_image_url }
          })
        }} />

      </TableCell>
      <TableCell>
        <ImageWrapper imageUrl={item.web_image_url} onImageClicked={() => {
          setImage({
            visible: true,
            image: { src: item.web_image_url }
          })
        }} />
      </TableCell>
      <TableCell>
        <a href={item?.meta?.action_url} className="link" target="_blank">
          {item?.meta?.action_url}
        </a>
      </TableCell>
      <TableCell>
        <div className="flex space-x-2 justify-end">
          <CustomButton
            onClick={onEdit}
            isIconButton={true}
          >
            <CustomIcon icon="edit" />
          </CustomButton>
          <DangerButton
            onClick={onDelete}
            isIconButton={true}
          >
            <CustomIcon icon="delete" />
          </DangerButton>
        </div>
      </TableCell>
    </TableRow>
  )
}

export { PredictionCandidateItem }
